/**
 * Answers of the in-app hire-clippers form (/contratar-clipadores). `value` is
 * what `createBrandLead` stores: the same Portuguese strings the public
 * /marcas/campanha form sends (../autoclipper-landing-page
 * QualificationForm.tsx), so sales reads both sources alike. `id` keys the
 * translated label, `hireClippers.options.<step>.<id>`. Budget values are the
 * API keys of that form's brand-lead-budgets.ts.
 */
export interface HireClippersOption {
  readonly id: string;
  readonly value: string;
}

export const DEMAND_TYPE_OPTIONS: readonly HireClippersOption[] = [
  { id: 'brand', value: 'Marca' },
  { id: 'creator', value: 'Creator' },
  { id: 'agency', value: 'Agência' },
  { id: 'infoproducer', value: 'Infoprodutor' },
  { id: 'podcast', value: 'Podcast' },
  { id: 'mediaGroup', value: 'Grupo de comunicação' },
  { id: 'seller', value: 'Seller / e-commerce' },
  { id: 'other', value: 'Outro' },
];

export const OBJECTIVE_OPTIONS: readonly HireClippersOption[] = [
  { id: 'awareness', value: 'Awareness' },
  { id: 'distributeContent', value: 'Distribuir conteúdo' },
  { id: 'launch', value: 'Lançamento' },
  { id: 'growAudience', value: 'Crescer audiência' },
  { id: 'sales', value: 'Gerar vendas' },
  { id: 'distributePodcast', value: 'Distribuir podcast' },
  { id: 'other', value: 'Outro' },
];

export const CONTENT_TYPE_OPTIONS: readonly HireClippersOption[] = [
  { id: 'readyContent', value: 'Conteúdo pronto' },
  { id: 'podcast', value: 'Podcast' },
  { id: 'longVideos', value: 'Vídeos longos' },
  { id: 'creators', value: 'Creators' },
  { id: 'ugc', value: 'UGC' },
  { id: 'archive', value: 'Acervo' },
  { id: 'product', value: 'Produto' },
  { id: 'needToProduce', value: 'Ainda preciso produzir' },
];

export const PLATFORM_OPTIONS: readonly HireClippersOption[] = [
  { id: 'tiktok', value: 'TikTok' },
  { id: 'instagram', value: 'Instagram' },
  { id: 'youtube', value: 'YouTube' },
  { id: 'multiple', value: 'Múltiplas' },
];

export const BUDGET_OPTIONS: readonly HireClippersOption[] = [
  { id: 'undecided', value: 'undecided' },
  { id: 'range_5k_10k', value: 'range_5k_10k' },
  { id: 'range_10k_20k', value: 'range_10k_20k' },
  { id: 'range_20k_50k', value: 'range_20k_50k' },
  { id: 'range_50k_150k', value: 'range_50k_150k' },
  { id: 'range_150k_plus', value: 'range_150k_plus' },
];
